import { defer, isFunction } from 'lodash/fp';

export function sideEffectMiddleware(store) {
    return (next) => (action) => {
        const { effect, immediateEffect } = action;

        if (isFunction(immediateEffect)) {
            immediateEffect({ action, store });
        }

        if (isFunction(effect)) {
            // Defering the effect allows the reducer to generate the
            // updated state first.
            defer(() => effect({ action, store }));
        }

        return next(action);
    };
}
